import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import portada from "../assets/portada.png";
import { useAuth } from "../hooks/useAuth";
import { useForm } from "../hooks/useForm";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../helpers/Routes";
import { use } from "react";
import { useTitle } from "../hooks/useTitle";
const Login = () => {
    
    

    const { signIn, autenticado } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const { form, onChange } = useForm({ email: "", password: "" });
    const { email, password } = form;

    const title = `Iniciar sesion`;
    useTitle({ title });

    let navigate = useNavigate();
    let location = useLocation();

    let from = location.state?.from?.pathname || routes.login;

    //useEffect para validar si existe una sesion abierta
    useEffect(() => {
        if (autenticado) navigate(from, { replace: true });
    }, [autenticado, navigate, from]);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, [location.pathname]);

      
    useEffect(() => {
        if (autenticado) {
            navigate(routes.home)
        }
    }, [autenticado])

    const handleLogin = (e) => {
        e.preventDefault();
        if (email.trim() === "" || password.trim() === "") {
            enqueueSnackbar("Todos los campos son obligatorios", {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                }
            });
            return;
        }


        signIn({ email, password }).catch((error) => {
            enqueueSnackbar(error, {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                }
            })
        });
    }
    return (
        <>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header />
                <div className="banner-productos">
                    <div className="portada">
                        <img src={portada} />
                        <p>Iniciar Sesión</p>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="info-contact">
                        <div style={{ flex: "0 0 70%" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                <div className="form-contact">
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Correo electrónico</label>
                                        <input type="text" name="email" id="email" value={email} onChange={(event) => onChange(event, "email")} placeholder="Escribe tu correo electrónico" />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Contraseña</label>
                                        <input type="password" id="password" name="password" placeholder="Escribe tu contraseña" value={password} onChange={(event) => onChange(event, "password")} />
                                    </div>
                                    <div>
                                        <button className="btn" onClick={handleLogin}>Iniciar Sesion</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div >
                <Footer />
            </div >
        </>
    );
}

export default Login;